/**
 * 能耗接口
 */
import Axios from '../axios.js'

export default {

	/*
	 * 获取指定设备指定时间范围内的订单数
	 * 
	 */
	countRecordByDeviceIdInTime(deviceId, bgTime, endTime, success, failure) {
		Axios.post('/siemens/countRecordByDeviceIdInTime.do', {
			deviceId,
			bgTime,
			endTime
		}, success, failure)
	},
	/*
	 * 获取指定设备指定时间范围内的充电时长
	 */
	countRecordUseTimeByDeviceIdInTime(deviceId, bgTime, endTime, success, failure) {
		Axios.post('/siemens/countRecordUseTimeByDeviceIdInTime.do', {
			deviceId,
			bgTime,
			endTime
		}, success, failure)
	},
	/**
	 * 查询充电桩在一定时间段的充值与消费记录
	 */
	searchRecordBetweenTime: (deviceId, beginTime, endTime, pageIndex, pageLen, success, failure) => {
		Axios.post('/siemens/searchRecordBetweenTime.do', {
			deviceId,
			beginTime,
			endTime,
			pageIndex,
			pageLen
		}, success, failure);
	},
	/**
	 * 根据充电桩id查询在一段时间内的消费记录次数和充电总时长以及消费总额
	 */
	sumTimeAndMoneyBetweenTime: (deviceIds, beginTime, endTime, success, failure) => {
		Axios.post('/siemens/sumTimeAndMoneyBetweenTime.do', {
			deviceIds,
			beginTime,
			endTime
		}, success, failure);
	},
	/**
	 * 当前用户有权限的虚拟设备关联到的，模板为西门子充电桩的，正在充电中的，台账设备，返回这个设备的id和充电中的订单信息
	 */
	getUsingRecordByUser: (success, failure) => {
		Axios.post('/siemens/getUsingRecordByUser.do', {}, success, failure);
	},
	/**
	 * 分页获取充电桩最新的订单列表（状态为消费中和消费完成的）
	 * beginTime
	 * endTime
	 */
	getRecordByDeviceIdsWithTime(deviceIds,state, beginTime, endTime, pageIndex, pageSize, success, failure) {
		Axios.post('/siemens/getRecordByDeviceIdsWithTime.do', {
			deviceIds,
			state,
			beginTime,
			endTime,
			pageIndex,
			pageSize,
		}, success, failure);
	},
	/**
	 * 批量查询指定的桩的状态，其实就是查询最近的一条订单，根据订单状态判断是使用中还是闲置中，0进行中1已完成
	 */
	getPileNearOrderByPileIds(deviceIds, success, failure) {
		Axios.post('/siemens/getPileNearOrderByPileIds.do', {
			deviceIds
		}, success, failure)
	},
	/**
	 * 创建充电记录
	 */
	createConsumptionOrder(deviceId, success, failure) {
		Axios.post('/siemens/createConsumptionOrder.do', {
			deviceId
		}, success, failure)
	},
	/**
	 * 充电完成，扣费
	 */
	confirmConsumptionOrder(recordId, detailId, amount, success, failure) {
		Axios.post('/siemens/confirmConsumptionOrder.do', {
			recordId,
			detailId,
			amount
		}, success, failure)
	},
	/**
	 * 获取所有充电站的名称和坐标
	 */
	getAllChargingStationInfo(success, failure) {
		Axios.post('/siemens/getAllChargingStationInfo.do', {}, success, failure)
	},
	/**
	 * 获取用户最近一次的消费中订单，如果有就说明正在充电
	 */
	getUserNearConsumptionOrder(success, failure) {
		Axios.post('/siemens/getUserNearConsumptionOrder.do', {}, success, failure)
	},
	/**
	 * 查询用户的充值与消费记录,时间倒序排列
	 */
	searchRecord(pageIndex, pageLen, success, failure) {
		Axios.post('/siemens/searchRecord.do', {
			pageIndex,
			pageLen
		}, success, failure)
	},
	/**
	 * 批量查询明细表的内容顺带查询虚拟设备名称
	 */
	getDetailByIds(detailIds, success, failure) {
		Axios.post('/siemens/getDetailByIds.do', {
			detailIds
		}, success, failure)
	},
	/**
	 * 根据充电桩id查询在一段时间内的每天的消费记录次数和充电总时长以及消费总额
	 */
	searchCountAndSumEveryDay(deviceIds, beginTime, endTime, success, failure) {
		Axios.post('/siemens/searchCountAndSumEveryDay.do', {
			deviceIds, beginTime, endTime,
		}, success, failure)
	},

}
